import { useState } from 'react';
import type { Entite } from '../types';

/**
 * Logo d'une entite, avec repli sur le logo Artistic.
 *
 * Le repli est necessaire a deux titres : une entite peut n'avoir jamais
 * recu de logo, et le fichier peut avoir disparu du disque — c'est la
 * limite connue du stockage local (cf. ADR-0010). Dans les deux cas
 * l'en-tete doit rester lisible plutot que d'afficher une image cassee.
 */
export function LogoEntite({
  entite,
  className = 'h-9 w-auto',
  /**
   * Change a chaque televersement pour forcer le navigateur a recharger :
   * la reponse est mise en cache un an, et l'URL ne contient que
   * l'identifiant de l'entite, pas celui du fichier.
   */
  version,
}: {
  entite: Entite | null | undefined;
  className?: string;
  version?: number;
}) {
  const [enEchec, setEnEchec] = useState(false);

  const source =
    entite?.logo && !enEchec
      ? `/api/entites/${entite.id}/logo${version ? `?v=${version}` : ''}`
      : '/assets/logo-artistic.jpg';

  return (
    <img
      src={source}
      alt={entite?.raison_sociale ?? 'Artistic'}
      className={className}
      onError={() => setEnEchec(true)}
    />
  );
}
